module.exports = __webpack_public_path__ + "img/gray-play-icon.8f677955.svg";